import {useState} from "react";
import {observer} from "mobx-react";
import {CatalogSortDto, FilterOption} from "../model/types";
import {CatalogSortOptionsFilter, mapCatalogSortOptions} from "@/features/catalog-sort";
import {catalogEvents} from "@/shared/lib/events";
import {useStoreMobx} from "@/shared/lib/mobx/useStoreMobx"; // Legacy
import {Svg} from "@/shared/ui/Svg";
import {FilterDropdown} from "@/shared/ui/FilterDropdown";
import styles from "./CatalogSort.module.scss";

type Props = {
    dataSort: CatalogSortDto[];
    isDesktop: boolean;
};

export const CatalogSort = observer((
    {
        dataSort,
        isDesktop,
    }: Props
) => {
    const [opened, setOpened] = useState(false);
    const {catalogStore} = useStoreMobx();

    const options = mapCatalogSortOptions({
        options: dataSort,
    });

    const handleChange = (option: FilterOption) => {
        catalogStore.applySorting(option);

        setOpened(false);
    };

    const handleMobileOpen = () => {
        catalogEvents.openCatalogFilter.emit({filterKey: "sorting"});
    };

    return (
        <FilterDropdown
            opened={opened}
            onOpenChange={setOpened}
            title={catalogStore?.selectedSortingName}
            titleClassName={styles.sortTitle}
            iconLeft={<Svg id={`sortFiltersIcon`} className={styles.icon} />}
            isDesktop={isDesktop}
            onMobileOpen={handleMobileOpen}
            filterType={`sort`}
        >
            <CatalogSortOptionsFilter
                options={options}
                selectedValue={catalogStore.selectedSortingValue}
                onChange={handleChange}
            />
        </FilterDropdown>
    );
});
